const config = {
  env: "local",
  // apiUrl: "https://issue-montgomery-bridge-regime.trycloudflare.com/api/",
  apiUrl: "https://apinew.goastrotalk.com/api/",
  // apiUrl: "http://192.168.0.122:5100/api/"
};

export default config;
